/* ============================================================
   222 WORLD — theme.js
   DROP 001
   ============================================================ */

(function () {
  'use strict';

  /* ============================================================
     SCROLL REVEAL
     ============================================================ */
  function initReveal() {
    var reveals = document.querySelectorAll('.reveal');
    if (!reveals.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function () {
            entry.target.classList.add('vis');
          }, i * 55);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    reveals.forEach(function (el) { obs.observe(el); });
  }

  /* ============================================================
     MOBILE MENU
     ============================================================ */
  function initMobileMenu() {
    var toggle = document.getElementById('MobileToggle');
    var menu = document.getElementById('MobileMenu');
    var close = document.getElementById('MobileClose');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      menu.classList.add('open');
      menu.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });

    function closeMenu() {
      menu.classList.remove('open');
      menu.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (close) close.addEventListener('click', closeMenu);
    menu.addEventListener('click', function (e) {
      if (e.target === menu) closeMenu();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  /* POPUP REMOVED — handled externally via Shopify app */

  /* ============================================================
     HOMEPAGE FILTER
     ============================================================ */
  function initFilter() {
    var btns = document.querySelectorAll('.fbtn');
    var wraps = document.querySelectorAll('.pcard-wrap');
    if (!btns.length || !wraps.length) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var cat = btn.getAttribute('data-cat');

        wraps.forEach(function (wrap) {
          var col = wrap.getAttribute('data-collection');
          var show = (cat === 'all' || col === cat || col === 'all');
          if (show) {
            wrap.style.display = '';
            var card = wrap.querySelector('.pcard');
            if (card) {
              card.classList.remove('hidden');
              setTimeout(function () { card.classList.add('vis'); }, 50);
            }
          } else {
            wrap.style.display = 'none';
          }
        });
      });
    });
  }

  /* ============================================================
     QUICK ADD TO CART (AJAX)
     ============================================================ */
  function showCartNotification(message) {
    var existing = document.querySelector('.cart-notification');
    if (existing) existing.remove();

    var notif = document.createElement('div');
    notif.className = 'cart-notification';
    notif.textContent = message || 'Added to cart';
    document.body.appendChild(notif);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        notif.classList.add('show');
      });
    });

    setTimeout(function () {
      notif.classList.remove('show');
      setTimeout(function () { notif.remove(); }, 400);
    }, 2800);
  }

  function updateCartCount(count) {
    var el = document.getElementById('CartCount');
    if (el) el.textContent = count;
  }

  function addToCart(variantId, btn) {
    if (!variantId) return;
    var originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (data.id) {
        // Update cart count
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateCartCount(cart.item_count); });
        showCartNotification('Added to cart — ' + data.product_title);
      } else {
        showCartNotification(data.description || 'Could not add to cart');
      }
    })
    .catch(function () {
      showCartNotification('Something went wrong. Try again.');
    })
    .finally(function () {
      btn.textContent = originalText;
      btn.disabled = false;
    });
  }

  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.quick-add');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (variantId) {
        addToCart(variantId, btn);
      }
    });
  }

  /* ============================================================
     PRODUCT PAGE
     ============================================================ */
  function initProductPage() {
    // Image gallery thumbnails
    var thumbs = document.querySelectorAll('.product-thumb');
    var mainImg = document.getElementById('ProductMainImg');
    if (thumbs.length && mainImg) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('active'); });
          thumb.classList.add('active');
          mainImg.src = thumb.getAttribute('data-src');
        });
      });
    }

    // Variant selection (swatches + size buttons)
    var variantSelect = document.getElementById('ProductSelect');
    var addBtn = document.getElementById('ProductAddBtn');
    var cartMsg = document.getElementById('ProductCartMsg');

    if (!variantSelect) return;

    // Build variant map
    var variantData = [];
    var options = variantSelect.querySelectorAll('option');
    options.forEach(function (opt) {
      variantData.push({
        id: opt.value,
        title: opt.textContent,
        available: !opt.disabled
      });
    });

    var selectedOptions = [];

    function updateVariant() {
      var selectedTitle = selectedOptions.join(' / ');
      var matched = variantData.find(function (v) {
        return v.title.indexOf(selectedTitle) !== -1 || selectedOptions.length === 0;
      });
      if (matched) {
        variantSelect.value = matched.id;
        if (addBtn) {
          addBtn.disabled = !matched.available;
          addBtn.textContent = matched.available ? 'Add to Cart' : 'Coming Soon';
          addBtn.setAttribute('data-variant-id', matched.id);
        }
      }
    }

    // Swatch click
    document.querySelectorAll('.product-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var idx = parseInt(swatch.getAttribute('data-option-index'));
        var val = swatch.getAttribute('data-value');
        var group = swatch.closest('.product-swatches');
        group.querySelectorAll('.product-swatch').forEach(function (s) { s.classList.remove('active'); });
        swatch.classList.add('active');

        var labelEl = document.getElementById('selected-' + swatch.closest('.product-option-group').querySelector('.product-option-label').textContent.split(':')[0].trim().toLowerCase().replace(/ /g, '-'));
        if (labelEl) labelEl.textContent = val;

        selectedOptions[idx] = val;
        updateVariant();
      });
    });

    // Size button click
    document.querySelectorAll('.product-size-btn').forEach(function (sizeBtn) {
      sizeBtn.addEventListener('click', function () {
        var idx = parseInt(sizeBtn.getAttribute('data-option-index'));
        var val = sizeBtn.getAttribute('data-value');
        var group = sizeBtn.closest('.product-size-btns');
        group.querySelectorAll('.product-size-btn').forEach(function (s) { s.classList.remove('active'); });
        sizeBtn.classList.add('active');
        selectedOptions[idx] = val;
        updateVariant();
      });
    });

    // Description accordion
    var descToggle = document.querySelector('.product-desc-toggle');
    var descBody = document.querySelector('.product-desc-body');
    if (descToggle && descBody) {
      descToggle.addEventListener('click', function () {
        var open = descBody.classList.toggle('open');
        descToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    // Add to cart via product form (AJAX)
    var productForm = document.getElementById('ProductForm');
    if (productForm && addBtn) {
      productForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var variantId = variantSelect.value;
        if (!variantId) return;

        addBtn.textContent = 'Adding...';
        addBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.id) {
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) { updateCartCount(cart.item_count); });
            if (cartMsg) {
              cartMsg.textContent = '✓ Added to cart';
              setTimeout(function () { cartMsg.textContent = ''; }, 3000);
            }
            addBtn.textContent = '✓ Added';
            setTimeout(function () {
              addBtn.textContent = 'Add to Cart';
              addBtn.disabled = false;
            }, 2000);
          } else {
            if (cartMsg) cartMsg.textContent = data.description || 'Could not add.';
            addBtn.textContent = 'Add to Cart';
            addBtn.disabled = false;
          }
        })
        .catch(function () {
          if (cartMsg) cartMsg.textContent = 'Something went wrong.';
          addBtn.textContent = 'Add to Cart';
          addBtn.disabled = false;
        });
      });
    }
  }

  /* ============================================================
     CART PAGE — QTY CONTROLS
     ============================================================ */
  function initCartPage() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.qty-btn');
      if (!btn) return;
      var action = btn.getAttribute('data-action');
      var line = btn.getAttribute('data-line');
      var input = document.querySelector('.qty-input[data-line="' + line + '"]');
      if (!input) return;
      var val = parseInt(input.value) || 0;
      if (action === 'increase') input.value = val + 1;
      if (action === 'decrease') input.value = Math.max(0, val - 1);
    });
  }

  /* ============================================================
     NAV SCROLL BEHAVIOR
     ============================================================ */
  function initNavScroll() {
    var nav = document.getElementById('SiteNav');
    if (!nav) return;
    window.addEventListener('scroll', function () {
      if (window.scrollY > 60) {
        nav.style.background = 'rgba(0,0,0,0.98)';
      } else {
        nav.style.background = 'rgba(0,0,0,0.92)';
      }
    }, { passive: true });
  }

  /* ============================================================
     INIT ALL
     ============================================================ */
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initMobileMenu();
    initFilter();
    initQuickAdd();
    initProductPage();
    initCartPage();
    initNavScroll();
  });

})();
